import { CONTACT_EMAIL } from "../config/contact";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { useLocalizedPath } from "../localization/urls";

export function Footer() {
  const { t } = useTranslation();
  const path = useLocalizedPath();
  return (
    <footer className="site-footer">
      <div className="wrap footer-inner">
        <p>
          <strong>{t("site.title")}</strong><br />
          {t("footer.note")}<br />
          <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>
        </p>
        <nav aria-label={t("footer.navigation")}><Link to={path("/map")}>{t("nav.map")}</Link><Link to={path("/catalog")}>{t("nav.catalogue")}</Link></nav>
      </div>
    </footer>
  );
}
